import React from 'react';
import { motion } from 'framer-motion';

const partnerLogos = [
  {
    name: 'NVIDIA',
    src: '/images/partners/Nvidia_logo.svg',
    href: 'https://nvidia.com/',
    heightClassName: 'h-8 md:h-10',
  },
  {
    name: 'Xsolla',
    src: '/images/partners/xsolla-logo.svg',
    href: 'https://xsolla.com/',
    heightClassName: 'h-8 md:h-10',
  },
  {
    name: 'Red Hat Linux',
    src: '/images/partners/redhat-logo.svg',
    href: 'https://www.redhat.com/',
    heightClassName: 'h-8 md:h-10',
  },
  {
    name: 'Ubuntu',
    src: '/images/partners/Ubuntu_logo.svg',
    href: 'https://ubuntu.com/',
    heightClassName: 'h-8 md:h-10',
  },
  {
    name: 'Huawei',
    src: '/images/partners/Huawei_logo.svg',
    href: 'https://www.huawei.com/en/',
    heightClassName: 'h-8 md:h-10',
  },
  {
    name: 'Business Development Bank of Canada',
    src: '/images/partners/bdc-logo.svg',
    href: 'https://www.bdc.ca/en',
    heightClassName: 'h-10 md:h-12',
  },
  {
    name: 'New Brunswick Innovation Foundation',
    src: '/images/partners/nbif-logo.svg',
    href: 'https://nbif.ca/',
    heightClassName: 'h-7 md:h-9',
  },
  {
    name: 'Dell Canada',
    src: '/images/partners/Dell_Logo.png',
    href: 'https://www.dell.com/',
    heightClassName: 'h-8 md:h-10',
  },
  {
    name: 'Patrii Cloud',
    src: '/images/partners/patrii-logo.svg',
    href: 'https://patrii.cloud/',
    heightClassName: 'h-8 md:h-10',
  },
  {
    name: 'EHConomics',
    src: '/images/partners/ehconomics-logo.png',
    href: 'https://www.ehconomics.com/',
    heightClassName: 'h-8 md:h-10',
  },
];

const marqueeLogos = [...partnerLogos, ...partnerLogos];

export default function PartnerLogoStrip() {
  return (
    <section className="px-6 py-16 md:py-20">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.5 }}
          className="mb-8 text-center"
        >
          <h2 className="mt-5 text-3xl font-semibold tracking-[-0.05em] text-white md:text-5xl">
            See whose excited about mapleos.
          </h2>
        </motion.div>

        <div className="relative overflow-hidden py-4">
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 md:w-28" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 md:w-28" />

          <div className="partner-logo-marquee flex min-w-max items-center gap-12 px-5 md:gap-16 md:px-7">
            {marqueeLogos.map((logo, index) => {
              const content = (
                <img
                  src={logo.src}
                  alt={logo.name}
                  className={`${logo.heightClassName} w-auto max-w-[180px] object-contain grayscale opacity-75 brightness-[1.55] contrast-95 transition-opacity duration-300`}
                  loading="lazy"
                />
              );

              return logo.href ? (
                <a
                  key={`${logo.name}-${index}`}
                  href={logo.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={logo.name}
                  className="shrink-0 transition-opacity duration-300 hover:opacity-80"
                >
                  {content}
                </a>
              ) : (
                <div key={`${logo.name}-${index}`} className="shrink-0">
                  {content}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}